import Axios from "axios";
import {
    SET_OT_INCENTIVE_REPORT_LIST, 
    UNSET_OT_INCENTIVE_REPORT_LIST
} from "@/store/mutation-types";
import {
    getOtIncentiveReport,
} from "@/store/api";

const state = {
    getOtIncentiveReport: [],
};

const getters = {
    getOtIncentiveReport(state) {
        return state.getOtIncentiveReport;
    },
};

const mutations = {
    [SET_OT_INCENTIVE_REPORT_LIST](state, data) {
        state.getOtIncentiveReport = data;
    },
    [UNSET_OT_INCENTIVE_REPORT_LIST](state) {
        state.getOtIncentiveReport = [];
    },
};

const actions = {

    getOtIncentiveReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getOtIncentiveReport}`, { params: data })
                .then((response) => {
                    commit(SET_OT_INCENTIVE_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_OT_INCENTIVE_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};